import { createSearchParams } from 'react-router-dom'

import { Box, Icon, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import Cell from 'modules/bookkeepers/components/TableComponents/Body/Cell'
import type { IncidenceQueryData } from 'modules/bookkeepers/hooks/useGetIncidences'
import useIncidenceTypeQueryParam from 'modules/bookkeepers/hooks/useIncidenceTypeQueryParam'
import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import incidenceHasMessage from 'modules/bookkeepers/lib/hasNewMessage'

import NotificationsIcons from './NotificationsIcons'

interface IconProps {
  selected: boolean
  applyStyles?: boolean
  updatesPath: string
}

const UpdatesIcon = ({ selected, updatesPath }: IconProps) => {
  return (
    <NotificationsIcons ariaLabel="updates" selected={selected} path={updatesPath}>
      <Icon.Small icon="small-bell" />
    </NotificationsIcons>
  )
}

const MessagesIcon = ({ selected, updatesPath, applyStyles = false }: IconProps) => {
  return (
    <NotificationsIcons
      ariaLabel="messages"
      selected={selected}
      path={updatesPath}
      iconsCombinationMessagesStyle={applyStyles}
    >
      <Icon.Small icon="small-envelope" />
    </NotificationsIcons>
  )
}

interface Props {
  selected: boolean
  incidence: IncidenceQueryData
}

const LastNameCell = ({ selected, incidence }: Props) => {
  const isBookkeeperView = useBookkeeperView()
  const hasUpdatesBookkeeper = isBookkeeperView && incidence.readAt === null
  const hasMessageBookkeeper = incidenceHasMessage(isBookkeeperView, incidence)
  const { navigation } = useNavigation()
  const textColor = selected ? 'grey000White' : 'grey1000'
  const { incidenceType } = useIncidenceTypeQueryParam()
  const incidenceTypeParams = createSearchParams({ incidenceType })
  const getPathWithParams = (basePath: string): string => {
    return incidenceType ? `${basePath}?${incidenceTypeParams}` : basePath
  }
  const updatesBasePath = navigation.bookkeepers.incidences.idChanges.fullPath({
    id: incidence.id,
  })
  const messagesBasePath = navigation.bookkeepers.incidences.idMessages.fullPath({
    id: incidence.id,
  })
  const messagesPath = getPathWithParams(messagesBasePath)
  const updatesPath = getPathWithParams(updatesBasePath)

  return (
    <>
      {isBookkeeperView && (
        <Table.Cell>
          <Box
            style={{ position: 'relative' }}
            maxWidth="s240"
            height="s32"
            flexDirection="column"
            justifyContent="center"
          >
            <Cell selected={selected} label={incidence.employee?.lastName} />
            {hasUpdatesBookkeeper && !hasMessageBookkeeper && (
              <UpdatesIcon selected={selected} updatesPath={updatesPath} />
            )}
            {hasMessageBookkeeper && !hasUpdatesBookkeeper && (
              <MessagesIcon selected={selected} updatesPath={messagesPath} />
            )}
            {hasMessageBookkeeper && hasUpdatesBookkeeper && (
              <Box style={{ position: 'absolute', top: '0', right: '0' }}>
                <MessagesIcon selected={selected} updatesPath={messagesPath} applyStyles />
                <UpdatesIcon selected={selected} updatesPath={updatesPath} />
              </Box>
            )}
          </Box>
        </Table.Cell>
      )}
      {!isBookkeeperView && (
        <Table.Cell>
          <Text.Normal color={textColor}>{incidence.employee?.lastName}</Text.Normal>
        </Table.Cell>
      )}
    </>
  )
}

export default observer(LastNameCell)
